const unloadSpeed = {
  VERY_SLOW: 'VERY_SLOW',
  SLOW: 'SLOW',
  NORMAL: 'NORMAL',
  FAST: 'FAST',
};

const getColor = speed => ({
  [unloadSpeed.VERY_SLOW]: '#F5222D',
  [unloadSpeed.SLOW]: '#FAAD14',
  [unloadSpeed.NORMAL]: '#52C41A',
  [unloadSpeed.FAST]: '#42B0D5',
})[speed];

const getKeys = () => Object.keys(unloadSpeed);
const getValues = () => Object.values(unloadSpeed);

export default {
  ...unloadSpeed,
  getColor,
  getKeys,
  getValues,
};
